import React from "react";

import Input from "./Input";
import type { InputProps } from "./Input";

export const SearchInput = (inputProps: InputProps) => {
  return (
    <div className="relative mt-4 flex items-center md:mt-0">
      <span className="absolute">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          className="mx-3 h-5 w-5 text-gray-400 dark:text-gray-600">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
          />
        </svg>
      </span>
      <Input type="text" placeholder="Type to search ..." className="pl-10" {...inputProps} />
    </div>
  );
};

export default SearchInput;
